module.exports = {
  title: '龙翼客车运营管理平台',
  baseUrl: '//ws.kingwings.cn/longyi/',
  socketServer: "ws.kingwings.cn/socket",
  //是否支持当天数据查询
  supportTodayDataQuery: true,
 routeStartTime: {}
}
